import { EmployeeSkillsService } from "../../services/index";

class SkillsDashboardController {

    constructor(private EmployeeSkillsService: EmployeeSkillsService,
                private $state: ng.ui.IStateService,
                private $stateParams: ng.ui.IStateParamsService) {
        "ngInject";
    }

    public $onInit = () => {
    }
}

export const skillsDashboardComponent = {
    controller: SkillsDashboardController,
    bindings: {
        employeeSkills: '<'
    },
    template: require('./skills.dashboard.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/skills/skills.dashboard.component.ts